import React from 'react'
import quote from "../assets/images/quote.svg"
import quoteOne from "../assets/images/quote (1).svg"


const HeroVitalityBox = () => {
  return (
   <div className="my-8 pt-8 px-4">
          <div className="main-container mx-auto text-center">
            <img
              src="https://cdn.blackincae.com/D57-vitality-box-l-otto.png"
              alt="vitality-box"
              className="mx-auto max-w-full w-[89%] h-auto"
            />

            <p className="mt-8 text-[#233751] font-bold md:text-[40px] text-[30px] text-center hidden md:block bold-font">
              <span className="inline-block align-top w-[48px] h-[34px]">
                <img
                  src={quote}
                  alt="Open Quote"
                  className="w-full h-full"
                />
              </span>
              Wake Up Everyday With Clear And Healthy Airways, <br />A Sharp
              Mind And So Much Energy You Feel Like A Kid Again
              <span className="inline-block align-bottom w-[48px] h-[34px] ml-1">
                <img
                  src={quoteOne}
                  alt="Close Quote"
                  className="w-full h-full"
                />
              </span>
            </p>
            <p className="mt-8 text-[#233751] font-bold md:text-[40px] text-[30px] bold-font text-center block md:hidden mx-2">
              <span className="inline-block align-top">
                <img
                  src={quote}
                  alt="Open Quote"
                  className="w-[20px] h-[20px]"
                />
              </span>
              Wake Up Everyday With Clear And Healthy Airways, A Sharp Mind And
              So Much Energy You Feel Like A Kid Again
              <span className="inline-block align-bottom w-[40px] h-[34px] ml-1">
                <img
                  src={quoteOne}
                  alt="Close Quote"
                  className="w-[20px] h-[20px]"
                />
              </span>
            </p>
          </div>
        </div>

  )
}

export default HeroVitalityBox;